(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('InfoModalApprovedController', InfoModalApprovedController);

    InfoModalApprovedController.$inject = ['$uibModalInstance', 'ApprovedItem', 'expoUserVirtualFairID', 'item', 'type', 'setMaxRepresentatives', 'VirtualFairService', '$rootScope','$scope', '$sce', 'toastr'];

    function InfoModalApprovedController($uibModalInstance, ApprovedItem, expoUserVirtualFairID, item, type, setMaxRepresentatives, VirtualFairService, $rootScope, $scope, $sce, toastr) {
        
        var vm = this;

        vm.ApprovedItem             = ApprovedItem;
        vm.type                     = type;
        vm.registered               = '';
        vm.query                    = [];
        vm.photos                   = [];
        vm.ok                       = ok;
        vm.cancel                   = cancel;
        vm.getPhotos                = getPhotos;
        vm.updateRepresentatives    = updateRepresentatives;
        vm.expoUserVirtualFairID    = expoUserVirtualFairID;
        vm.maxRepresentatives       = null;
        vm.setMaxRepresentatives    = setMaxRepresentatives;

        console.log(setMaxRepresentatives);

        activate();

        $scope.trustSrc = function(src) {
            return $sce.trustAsResourceUrl(src);
        }

        function activate() {
            vm.maxRepresentatives = parseInt(item.max_representatives);
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function getPhotos(album) {
            album.toggle = !album.toggle;
            if(typeof album.check === 'undefined') {
                VirtualFairService.getPhotos(album).then(function(response){
                    album.photos = response.data;
                    album.check = true;

                }).catch(function(err) {
                    alertify.notify(err, 'danger', 3);
                });
            }
        }

        function updateRepresentatives () {
            let query = {};
            query['max_representatives'] = vm.maxRepresentatives;
            VirtualFairService.setMaxRepresentatives(vm.expoUserVirtualFairID, query).then(function(response) {
                item.max_representatives = vm.maxRepresentatives;
                toastr.success('Number of representatives successfully updated!');
            }).catch(function(err) {
                toastr.error('An error ocurred on update number of representatives!');
            })
        }

    }

})();